export default __webpack_public_path__ + "static/media/settinggear.fe7faad1.svg";